import { generateAlias } from '../string/index.js';

export const pathFolderName = generateAlias;
